"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _pendingFactory3 = _interopRequireDefault(require("./pendingFactory"));

var _default = function _default(func) {
  var dataMap = {};
  var queueMap = {};
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(key) {
      var _len,
          args,
          _key,
          _dataMap$key,
          state,
          data,
          _pendingFactory,
          _pendingFactory2,
          pending,
          ready,
          error,
          result,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = _args[_key];
              }

              if (!(typeof key !== 'string')) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", func.apply(void 0, [key].concat(args)));

            case 3:
              if (!dataMap.hasOwnProperty(key)) {
                _context.next = 16;
                break;
              }

              _dataMap$key = dataMap[key], state = _dataMap$key.state, data = _dataMap$key.data;
              _context.t0 = state;
              _context.next = _context.t0 === 1 ? 8 : _context.t0 === 2 ? 14 : _context.t0 === 3 ? 15 : 16;
              break;

            case 8:
              _pendingFactory = (0, _pendingFactory3.default)(), _pendingFactory2 = (0, _slicedToArray2.default)(_pendingFactory, 3), pending = _pendingFactory2[0], ready = _pendingFactory2[1], error = _pendingFactory2[2];

              if (!queueMap.hasOwnProperty(key)) {
                queueMap[key] = [];
              }

              queueMap[key].push({
                ready: ready,
                error: error
              });
              _context.next = 13;
              return pending;

            case 13:
              return _context.abrupt("return", _context.sent);

            case 14:
              return _context.abrupt("return", data);

            case 15:
              throw data;

            case 16:
              _context.prev = 16;
              dataMap[key] = {
                state: 1
              };
              _context.next = 20;
              return func.apply(void 0, [key].concat(args));

            case 20:
              result = _context.sent;
              dataMap[key] = {
                state: 2,
                data: result
              };

              if (queueMap.hasOwnProperty(key)) {
                queueMap[key].forEach(function (_ref2) {
                  var ready = _ref2.ready;
                  ready(result);
                });
                delete queueMap[key];
              }

              return _context.abrupt("return", result);

            case 26:
              _context.prev = 26;
              _context.t1 = _context["catch"](16);
              dataMap[key] = {
                state: 3,
                data: _context.t1
              };

              if (queueMap.hasOwnProperty(key)) {
                queueMap[key].forEach(function (_ref3) {
                  var error = _ref3.error;
                  error(_context.t1);
                });
                delete queueMap[key];
              }

              throw _context.t1;

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16, 26]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.default = _default;
//# sourceMappingURL=promiseOnce.js.map